(function () {
  var button = document.querySelector("[data-ogc-custom-designer-button]");
  if (!button) return;

  var form = button.closest('form[action*="/cart/add"]');
  if (!form) return;
  var toolsOrigin = button.dataset.toolsOrigin || "https://tools.onegoodcard.com";
  var handle = button.dataset.productHandle;
  var frame;
  var overlay;
  var pageParams = new URLSearchParams(window.location.search);
  var editingLine = pageParams.get("ogc_line") || "";
  var editingDesignId = pageParams.get("ogc_design_id") || "";

  function dataUrlFile(dataUrl, filename) {
    var match = /^data:([^;,]+);base64,(.*)$/.exec(dataUrl || "");
    if (!match) throw new Error("The artwork file is invalid.");
    var binary = atob(match[2]);
    var bytes = new Uint8Array(binary.length);
    for (var i = 0; i < binary.length; i += 1) bytes[i] = binary.charCodeAt(i);
    return new File([bytes], filename, { type: match[1] || "image/png" });
  }

  function setTextProperty(name, value) {
    var input = form.querySelector('[data-ogc-custom-property="' + name + '"]');
    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = "properties[" + name + "]";
      input.dataset.ogcCustomProperty = name;
      form.appendChild(input);
    }
    input.value = value || "";
  }

  function setArtworkProperty(name, dataUrl, filename) {
    var oldInput = form.querySelector('[data-ogc-custom-artwork="' + name + '"]');
    if (oldInput) oldInput.remove();
    var input = document.createElement("input");
    input.type = "file";
    input.hidden = true;
    input.name = "properties[" + name + "]";
    input.dataset.ogcCustomArtwork = name;
    var transfer = new DataTransfer();
    transfer.items.add(dataUrlFile(dataUrl, filename));
    input.files = transfer.files;
    form.appendChild(input);
    form.enctype = "multipart/form-data";
  }

  function closeDesigner() {
    if (overlay) overlay.remove();
    overlay = null;
    frame = null;
    document.documentElement.style.overflow = "";
  }

  async function getProductPricing() {
    var priceCents = Number(button.dataset.productPriceCents || 0);
    var currency = button.dataset.productCurrency || window.Shopify && window.Shopify.currency && window.Shopify.currency.active || "SGD";
    var oneYearWarrantyCents = 500;
    var threeYearsWarrantyCents = 1000;
    try {
      var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || "/";
      var response = await fetch(root.replace(/\/?$/, "/") + "products/" + encodeURIComponent(handle) + ".js", { credentials: "same-origin", headers: { Accept: "application/json" } });
      if (response.ok) {
        var product = await response.json();
        var variantInput = form.querySelector('[name="id"]');
        var selectedVariantId = Number(variantInput && variantInput.value);
        var selectedVariant = product.variants && product.variants.find(function (variant) { return Number(variant.id) === selectedVariantId; });
        priceCents = Number((selectedVariant || product.variants && product.variants[0] || {}).price) || priceCents;
      }
    } catch (error) {
      console.warn("[OGC Custom Designer] Using the product page price fallback.", error);
    }
    try {
      var warrantyResponse = await fetch(toolsOrigin + "/api/shopify/custom-designer-warranty-prices?countryCode=" + encodeURIComponent(button.dataset.countryCode || "SG"), { headers: { Accept: "application/json" } });
      if (warrantyResponse.ok) {
        var warrantyPricing = await warrantyResponse.json();
        currency = warrantyPricing.currencyCode || currency;
        oneYearWarrantyCents = Number(warrantyPricing.oneYearCents) || oneYearWarrantyCents;
        threeYearsWarrantyCents = Number(warrantyPricing.threeYearsCents) || threeYearsWarrantyCents;
      }
    } catch (error) {
      console.warn("[OGC Custom Designer] Using the warranty price fallback.", error);
    }
    return { priceCents: priceCents, currency: currency, oneYearWarrantyCents: oneYearWarrantyCents, threeYearsWarrantyCents: threeYearsWarrantyCents };
  }

  async function openDesigner() {
    var pricing = await getProductPricing();
    overlay = document.createElement("div");
    overlay.className = "ogc-custom-designer-overlay";
    overlay.innerHTML = '<div class="ogc-custom-designer-modal"></div>';
    frame = document.createElement("iframe");
    frame.className = "ogc-custom-designer-frame";
    frame.title = handle === "mini-custom-nfc-sticker" ? "Custom Mini designer" : "Custom card designer";
    frame.allow = "clipboard-write";
    var priceParams = new URLSearchParams({
      priceCents: String(pricing.priceCents || 0),
      currency: pricing.currency,
      oneYearWarrantyCents: String(pricing.oneYearWarrantyCents || 500),
      threeYearsWarrantyCents: String(pricing.threeYearsWarrantyCents || 1000)
    });
    if (editingLine) priceParams.set("editLine", editingLine);
    if (editingDesignId) priceParams.set("designId", editingDesignId);
    var frontArtwork = pageParams.get("ogc_Front Artwork");
    var backArtwork = pageParams.get("ogc_Back Artwork");
    var savedWarranty = pageParams.get("ogc_Warranty");
    if (frontArtwork) priceParams.set("frontArtwork", frontArtwork);
    if (backArtwork) priceParams.set("backArtwork", backArtwork);
    if (savedWarranty) priceParams.set("warranty", savedWarranty);
    frame.src = toolsOrigin + "/custom-product-designer/" + encodeURIComponent(handle) + "?" + priceParams.toString();
    overlay.firstChild.appendChild(frame);
    document.body.appendChild(overlay);
    document.documentElement.style.overflow = "hidden";
    overlay.addEventListener("click", function (event) { if (event.target === overlay) closeDesigner(); });
  }

  async function addDesignToCart(payload) {
    button.disabled = true;
    var sourceVariantInput = form.querySelector('[name="id"]');
    var sourceVariantId = String(sourceVariantInput && sourceVariantInput.value || button.dataset.productVariantId || "");
    setArtworkProperty("Front Artwork", payload.frontArtwork, "custom-front-artwork.png");
    if (payload.backArtwork) setArtworkProperty("Back Artwork", payload.backArtwork, "custom-back-artwork.png");
    if (payload.cleanBackArtwork) setArtworkProperty("_Back Artwork - No QR NFC", payload.cleanBackArtwork, "custom-back-artwork-no-qr-nfc.png");
    if (payload.miniSquareArtwork) setArtworkProperty("_Mini Full Square Artwork", payload.miniSquareArtwork, "custom-mini-full-square-artwork.png");
    if (payload.designPackage) setArtworkProperty("_Design Elements Package", payload.designPackage, "custom-design-elements.zip");
    setTextProperty("Warranty", payload.warranty);
    setTextProperty("_OGC_Customizable", "true");
    setTextProperty("_OGC_CustomDesigner", "true");
    setTextProperty("_OGC_DesignId", payload.designId);
    setTextProperty("_OGC_LineId", payload.designId);
    setTextProperty("_OGC_SourceHandle", handle);
    setTextProperty("_OGC_SourceVariantId", sourceVariantId);

    var warrantyCents = payload.warranty.indexOf("1 Year") !== -1 ? 500 : payload.warranty.indexOf("3 Years") !== -1 ? 1000 : 0;
    var pricedVariantId = "";
    if (warrantyCents) {
      var pricingResponse = await fetch(toolsOrigin + "/api/shopify/custom-designer-priced-product", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ handle: handle, sourceVariantId: sourceVariantId, countryCode: button.dataset.countryCode || "SG", warrantyCents: warrantyCents })
      });
      var pricingBody = await pricingResponse.json().catch(function () { return {}; });
      if (!pricingResponse.ok || !pricingBody.variantId) throw new Error(pricingBody.error || "We could not prepare the warranty price.");
      pricedVariantId = String(pricingBody.variantId);
    }
    setTextProperty("_OGC_PricedItem", pricedVariantId ? "true" : "");

    var cartFormData = new FormData(form);
    if (pricedVariantId) cartFormData.set("id", pricedVariantId);
    cartFormData.set("quantity", "1");

    var response = await fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || "/").replace(/\/?$/, "/") + "cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { Accept: "application/json" },
      body: cartFormData
    });
    if (!response.ok) throw new Error("We could not add your custom design to cart.");

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || "/").replace(/\/?$/, "/");
    if (editingLine) {
      var cartResponse = await fetch(root + "cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } });
      var cart = cartResponse.ok ? await cartResponse.json() : { items: [] };
      var changes = {};
      var removedLegacyWarranty = false;
      changes[editingLine] = 0;
      (cart.items || []).forEach(function (item) {
        if (!item.properties || item.properties._OGC_AddOn !== "true") return;
        if (editingDesignId && item.properties._OGC_ParentDesignId === editingDesignId) changes[item.key] = 0;
        else if (!editingDesignId && !removedLegacyWarranty && item.properties._OGC_CustomProduct === handle) { changes[item.key] = 0; removedLegacyWarranty = true; }
      });
      await fetch(root + "cart/update.js", { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ updates: changes }) });
    }

    window.location.assign("/cart");
  }

  button.addEventListener("click", function (event) {
    event.preventDefault();
    openDesigner().catch(function (error) {
      console.error("[OGC Custom Designer]", error);
      alert("We could not open the customiser. Please try again.");
    });
  });
  window.addEventListener("message", function (event) {
    if (!frame || event.origin !== toolsOrigin || event.source !== frame.contentWindow) return;
    if (event.data && event.data.type === "OGC_CUSTOM_DESIGN_CLOSE") { closeDesigner(); return; }
    if (event.data && event.data.type === "OGC_CUSTOM_DESIGN_ADD_TO_CART") {
      addDesignToCart(event.data.payload).catch(function (error) {
        console.error("[OGC Custom Designer]", error);
        alert(error.message || "We could not save your custom design. Please try again.");
        button.disabled = false;
        if (frame && frame.contentWindow) frame.contentWindow.postMessage({ source: "ogc-custom-designer", type: "OGC_CUSTOM_DESIGN_ADD_ERROR" }, toolsOrigin);
      });
    }
  });

  var style = document.createElement("style");
  style.textContent = "#ogc-custom-designer-button{display:inline-flex!important;align-items:center!important;justify-content:center!important;gap:8px!important;line-height:1!important;transition:background-color .18s ease!important}#ogc-custom-designer-button svg{display:block!important;width:18px!important;height:18px!important;flex:0 0 18px!important;margin:0!important}#ogc-custom-designer-button span{display:block!important;line-height:1.2!important}#ogc-custom-designer-button:hover,#ogc-custom-designer-button:focus-visible{background-color:#0047ad!important}.ogc-custom-designer-overlay{position:fixed;inset:0;z-index:2147483000;background:rgba(0,0,0,.55);padding:18px}.ogc-custom-designer-modal{position:relative;width:100%;height:100%;overflow:hidden;border-radius:18px;background:#fff;box-shadow:0 28px 90px rgba(0,0,0,.35)}.ogc-custom-designer-frame{display:block;width:100%;height:100%;border:0}@media(max-width:749px){.ogc-custom-designer-overlay{padding:0}.ogc-custom-designer-modal{border-radius:0}}";
  document.head.appendChild(style);
  if (pageParams.get("ogc_custom_designer") === "1" && pageParams.get("ogc_edit") === "1" && editingLine) openDesigner().catch(function (error) { console.error("[OGC Custom Designer]", error); });
})();
